import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Upload, Form, Button, Input, Typography, Modal, Space, Row, Col, Table, InputNumber, Select } from 'antd'
import { Queries, Mutations } from '../../../../../graphql'
import { numberWithCommas } from '../../../../../utils/number'
import { changeFormatdate, changeFormatdateThai, changeFormatMonthYearThai, changeFormatdateDayMonth } from '../../../../../utils/formatdate'
import ModalConfirmForm from '../../../../../components/user/ModalConfirmForm'
import { alertMessage } from '../../../../../utils/message'

const { Text, Title } = Typography
const { Option } = Select;

const formItemLayout = {
	labelCol: {
	  xs: { span: 24 },
	  sm: { span: 8 },
	},
	wrapperCol: {
	  xs: { span: 24 },
	  sm: { span:16 },
	},
  };

class ModalForm1 extends Component {
	state = {
		dataTable:[],
        columns:[
			{
                title: 'เปอร์เซ็นสะสม',
                dataIndex: 'provEmployeeDeduct',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{item.toFixed(2)}</span>
            },
            {
                title: 'วันที่แก้ไข',
                dataIndex: 'modifiedDate',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => <span>{ changeFormatdate(item)}</span>
            }
        ],
		configDataProvPercentage: null,
		summarySalary: null,
		preLoadTable: false,
		statusForm: false,
		ModalConfirmFormShowModal:false,
        ModalConfirmFormBtnOk:null,
        ModalConfirmFormBtnCancel:null,
        ModalConfirmFormValue:null,
        ModalConfirmFormStatus:null,
		ModalConfirmFormMessage:null,
        showModalNoteSession: false,
	}

	onChangeInputNumber = async (values) =>{
		const { configDataProvPercentage } = this.state
		// console.log('vasfdfasdf', values)	
		let summarySalary =  ( parseFloat(configDataProvPercentage.salary) * values) / 100
 		await this.setState({
			summarySalary
		})
	}

	fetchConfigChangeProvPercentage = async () =>{
		const { client, location } = this.props

		const { data, errors } = await client.query({
			query: Queries.fetchConfigChangeProvPercentage,
		})

        if(data.fetchConfigChangeProvPercentage){
            await this.setState({
                dataTable: data.fetchConfigChangeProvPercentage.provRateHistory,
				preLoadTable: false
            })
        }else{
			await this.setState({
				preLoadTable: false
            })
		}
	}

	handleSubmit = async () =>{
		const { form, client, hideModalCondition1 } = this.props
		const { ModalConfirmFormValue, configDataProvPercentage, statusForm } = this.state

		await this.setState({
			preLoadTable: true
		})

		console.log('123123123',ModalConfirmFormValue)

		const { data, errors } = await client.mutate({
			mutation: Mutations.createFundRateChange,
			variables: {
				provEmployeeDeduct : ModalConfirmFormValue.provEmployeeDeduct,
				fundPolicyId: configDataProvPercentage.fundPolicyId,
				status: statusForm
			}
		})

		console.log('data.createFundRateChange.',data.createFundRateChange)

		if(data.createFundRateChange.status){
			await this.fetchConfigChangeProvPercentage()
			await this.hideModalConfirm()
			await hideModalCondition1()
			if(statusForm == 'DRAFT'){
                alertMessage("success","บันทึกร่างสำเร็จ")
            }else if(statusForm == 'PENDING'){
                alertMessage("success","ส่งดำเนินการสำเร็จ")
            }
		}
	}

	showModalConfirm = async (e) =>{
		const { configDataProvPercentage, statusForm } = this.state

		let ModalConfirmFormTitle = ''
		e.preventDefault()
		this.props.form.validateFields( async(err, values) => {
			if(values.provEmployeeDeduct >= configDataProvPercentage.changeMin){
				if (!err) {
					if(statusForm == 'DRAFT'){
                        ModalConfirmFormTitle = 'ยืนยันการบันทึกร่าง'
                    }else if(statusForm == 'PENDING'){
                        ModalConfirmFormTitle = 'ยืนยันการเปลี่ยนแปลงการหักเงินสะสม'
                    }

					await this.setState({
						ModalConfirmFormTitle,
						ModalConfirmFormShowModal:true,
						ModalConfirmFormBtnOk:"ตกลง",
						ModalConfirmFormBtnCancel:'ยกเลิก',
						ModalConfirmFormValue:values,
						ModalConfirmFormStatus: null,
						ModalConfirmFormMessage: null,
						ModalFormTextArea: null,
						ModalFormTextAreaRequie: null
					})
				}
			}else{
				alertMessage('error','ต้องไม่เกิน ร้อยละ '+numberWithCommas(configDataProvPercentage.changeMax)+' กับ ต้องมากกว่า ร้อยละ '+numberWithCommas(configDataProvPercentage.changeMin))
			}
		});
	}

	hideModalConfirm = async () =>{
        await this.setState({
            ModalConfirmFormTitle:null,
            ModalConfirmFormSubTitle:null,
            ModalConfirmFormShowModal:false,
            ModalConfirmFormBtnOk:null,
            ModalConfirmFormBtnCancel:null,
            ModalConfirmFormValue:null,
            ModalConfirmFormStatus:null,
            ModalConfirmFormMessage:null,
            preLoadOnsubmit: false
        })
    }

	renderDropDownMinMax = () =>{
		const { configDataProvPercentage } = this.state
		if(configDataProvPercentage){
			let optionArray = []
			for (var i=configDataProvPercentage.changeMin ; i <= configDataProvPercentage.changeMax; i++) {
				optionArray.push(<Option value={i}>{numberWithCommas(i)}</Option>)
			}

			return optionArray
		}
	}


	async componentDidMount(){
		// const { configDataProvPercentage } = this.props
		// await this.setState({
		// 	configDataProvPercentage
		// })
    }

	async componentDidUpdate(prevProps) {
		if (this.props.configDataProvPercentage !== prevProps.configDataProvPercentage) {
			let summarySalary =  ( parseFloat(this.props.configDataProvPercentage.salary) * this.props.configDataProvPercentage.provEmployeeDeduct) / 100
			await this.setState({
				configDataProvPercentage: this.props.configDataProvPercentage,
				dataTable: this.props.configDataProvPercentage.provRateHistory,
				summarySalary
			})
		}
	  }

	render() {
		const { modalCondition1, hideModalCondition1 } = this.props
		const { getFieldDecorator } = this.props.form;
		const { 
				dataTable, 
				columns, 
				configDataProvPercentage, 
				summarySalary,
				ModalConfirmFormTitle,
				ModalConfirmFormSubTitle,
				ModalConfirmFormShowModal,
				ModalConfirmFormBtnOk,
				ModalConfirmFormBtnCancel,
				ModalConfirmFormValue,
				ModalFormTextArea,
				ModalFormTextAreaRequie,
				preLoadTable
		} = this.state
		// console.log('configDataProvPercentage', configDataProvPercentage)
		return (
			<>
				<ModalConfirmForm 
					title={ModalConfirmFormTitle} 
					subtitle={ModalConfirmFormSubTitle}
					showModal={ModalConfirmFormShowModal} 
					btnOk={ModalConfirmFormBtnOk} 
					btnCancel={ModalConfirmFormBtnCancel}  
					submitToSend={ this.handleSubmit }
					hideModal={ this.hideModalConfirm }
					valueConfirm = { ModalConfirmFormValue }
					ModalFormTextArea = {ModalFormTextArea}
					ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
				/>
				<Modal
					destroyOnClose={true}
					maskClosable={false}
					visible={modalCondition1}
					// visible={true}
					title={ <p className="color-red mb-0">เปลี่ยนแปลงการหักอัตราเงินสะสม</p> }
					// onOk={this.handleOk}
					onCancel={ hideModalCondition1 }
					width={800}
					footer={''}
				>
					<>
						<Form {...formItemLayout} onSubmit={this.showModalConfirm}>
							<Form.Item label="เงินเดือน" labelAlign="left" className="mb-1">
								<Input className="w-50 mr-4" disabled={true} value={configDataProvPercentage ? numberWithCommas(configDataProvPercentage.salary) : ''}/>
								<span className="ant-form-text">บาท</span>
							</Form.Item>

							{/* <Form.Item label="ปัจจุบันหักงินสะสมร้อยละ" labelAlign="left" className="mb-1">
								<Input className="w-50 mr-4" disabled={true} value={configDataProvPercentage ? numberWithCommas(configDataProvPercentage.provEmployeeDeduct) : ''}/>
							</Form.Item> */}

							<Form.Item label="หักเงินสะสมร้อยละ" labelAlign="left" className="mb-1">
								{getFieldDecorator('provEmployeeDeduct', {
									initialValue: configDataProvPercentage ? configDataProvPercentage.provEmployeeDeduct >= configDataProvPercentage.changeMin ? configDataProvPercentage.provEmployeeDeduct : numberWithCommas(configDataProvPercentage.provEmployeeDeduct) : '',
									rules: [{ required: true, message: 'กรุณาระบุจำนวนหักเงินสะสมร้อยละ' }],
								})(
									// <InputNumber 
									// 	min={configDataProvPercentage ? configDataProvPercentage.changeMin : '' } 
									// 	max={configDataProvPercentage ? configDataProvPercentage.changeMax : '' } 
									// 	className="w-50 mr-4 input-number ant-input-number-input-left"
									// 	onBlur={ (e) => this.onChangeInputNumber(e.target.value) }
									// 	parser={item => item.replace(/\$\s?|(,*)/g, '')}
									// 	formatter={item => `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
									// 	// onChange={}
									// />
									<Select onChange={ (e) => this.onChangeInputNumber(e) } className="w-50">
										{ this.renderDropDownMinMax() }
										{/* <Option value="15">Jack</Option>
										<Option value="10">Lucy</Option> */}
									</Select>
								)}
							</Form.Item>

							<Form.Item label="การหักรายได้ต่อเดือน" labelAlign="left" className="mb-1">
								<Input 
									className="w-50 mr-4" 
									disabled={true}
									value={summarySalary ? numberWithCommas(summarySalary) : ''}
								/>
							</Form.Item>

							<Row className="mt-3">
								<Col>
									<strong>
										เงื่อนไข
									</strong>
									<ol>
										<li>
											สามารถเปลี่ยนแปลงการหักเงินสะสมได้ตั้งแต่วันที่ {configDataProvPercentage ? changeFormatdateDayMonth(configDataProvPercentage.provChangeDateFrom) : ''} ถึง  {configDataProvPercentage ? changeFormatdateDayMonth(configDataProvPercentage.provChangeDateTo) : ''} ของทุกปี
										</li>
										<li>
											สามารถเปลี่ยนแปลงการหักเงินสะสมร้อยละ 
											<span className="mx-1">{ configDataProvPercentage ? numberWithCommas(configDataProvPercentage.changeMin) : '' }</span>
											และ สูงสุดไม่เกินร้อยละ 
											<span className="mx-1">{ configDataProvPercentage ? numberWithCommas(configDataProvPercentage.changeMax) : '' }</span>
										</li>
										<li>
											การเปลี่ยนแปลงเงินสะสมจะมีผลวันที่ {configDataProvPercentage ? changeFormatdateDayMonth(configDataProvPercentage.providentFundEffectiveDate) : ''} ของทุกปี
										</li>
									</ol>
								</Col>
							</Row>

							<Row className="mt-3">
								<Col style={{ textAlign:"center"}}>
									<Button className="btn-white-red" onClick={hideModalCondition1}>
										ปิด
									</Button>
									<Button 
										className="mx-2 btn-white-red" 
										onClick={async () => await this.setState({
											statusForm: "DRAFT"
										})}
										type="primary" 
										htmlType="submit" 
									>
										บันทึกร่าง
									</Button>
									<Button 
										type="primary" 
										htmlType="submit" 
										className="color-white"
										onClick={async () => await this.setState({
											statusForm: "PENDING"
										})}
									>
										ส่งดำเนินการ
									</Button>
								</Col>
							</Row>
						</Form>
					</>
				</Modal>
			</>
		)
	}
}

ModalForm1.defaultProps = {
	autoFocus: false
}

ModalForm1.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedModalForm1 = Form.create()(ModalForm1)

export default withApollo(WrappedModalForm1)